<section id="project1" class="projects" data-scroll-nav="0">
	<div class="container-fluid">
		<div class="row">
			<div class="col-xxl-9 col-xl-10 col-lg-11 col-md-11 col-sm-11 col-11 mx-auto">
				<div class="row">
					<div class="col-xl-7 col-md-7 col-sm-6" data-aos="fade-up" data-aos-duration="2000" data-aos-delay="100">
						<div class="d-flex flex-column justify-content-center h-100 service-content"
						
						>
							<div>
								<h1 class="heading">SPACEXFITNESS</h1>
								<div class="points">
									<p>
										SpaceX Fitness embodies a fusion of cutting-edge fitness
										technology and expert coaching, propelling individuals to
										new heights of strength and vitality.
									</p>
									<p>
										<a class="text-decoration-underline" href="https://spacexfitness.in"
											target="_blank">spacexfitness.in</a>
									</p>
								</div>
							</div>
						</div>
					</div>
					<div class="col-xl-5 col-md-5 col-sm-6">
						<div class="d-flex flex-column justify-content-center align-items-sm-end">
							<div class="list-block">
								<h3 class="mt-0 mb-2" data-aos="fade-up" data-aos-duration="1000" data-aos-delay="100">
									<a href="{{ Url }}/project-details/spacex#branding">Branding</a>
								</h3>
								<h3 class="mt-0 mb-2" data-aos="fade-up" data-aos-duration="1500" data-aos-delay="150">
									<a href="{{ Url }}/project-details/spacex#ui-ux">UI/UX Design</a>
								</h3>
								<!-- <h3 class="mt-0 mb-2" data-aos="fade-up" data-aos-duration="2000" data-aos-delay="200"><a
										href="{{Url}}/project-details/beyou#ecommerce">Ecommerce</a></h3> -->
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</section>
<section data-scroll-nav="1" class="pb-0">
	<div class="container-fluid p-0">
		<div class="row">
			<div class="col-md-12 p-0" data-aos="fade-up" data-aos-duration="2000" data-aos-delay="100">
				<img src="{{ baseUrl }}/images/projects/spacex/spacex-banner-min.png" alt="Best Web Designers in Dubai" width=""
					height="" loading="lazy" />
			</div>
		</div>
	</div>
</section>
<section class="section bg-autokoorosh about" data-scroll-nav="2">
	<div class="container">
		<div class="row">
			<div class="col-xxl-9 col-xl-10 col-lg-11 col-md-11 col-sm-11 col-11 mx-md-0 mx-sm-auto mx-auto"
				data-aos="fade-up" data-aos-duration="2000" data-aos-delay="100">
				<div class="content">
					<p class="mb-0">
						Pixtar was tasked with encapsulating the essence of our innovative
						approach to fitness into a digital platform. We entrusted Pixtar not
						only with capturing our brand's dynamic spirit but also with
						creating a seamless and engaging website that reflects our
						commitment to excellence in health and wellness.
					</p>
				</div>
			</div>
		</div>
	</div>
</section>

<section class="bg-autokoorosh branding pb-0" id="branding" data-scroll-nav="3">
	<div class="container">
		<div class="row">
			<div class="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-11 col-11 mx-md-0 mx-sm-auto mx-auto" data-aos="fade-up"
				data-aos-duration="2000" data-aos-delay="100">
				<div class="content">
					<h1 class="heading mb-0">Branding</h1>
					<p>
						In addition to website development, Pixtar undertook comprehensive
						branding work for SpaceX. This included creating a cohesive visual
						identity that aligned with their values and industry positioning.
						From logo design to color schemes and typography, every element was
						carefully crafted to reflect the brand's professionalism and
						expertise.
					</p>
				</div>
			</div>
		</div>
	</div>
</section>

<section class="bg-autokoorosh branding" id="branding1">
	<div class="container-fluid">
		<div class="row">
			<div class="col-md-12 p-0" data-aos="fade-up" data-aos-duration="2000" data-aos-delay="100">
				<div class="imglist mb-3">
					<img src="{{ baseUrl }}/images/projects/spacex/spacex-branding.png" alt="graphic design company" width=""
						height="" loading="lazy" />
				</div>
			</div>
			<div class="col-xxl-10 col-xl-11 col-lg-11 col-md-11 col-sm-11 col-11 mx-auto">
				<div class="row">
					<div class="col-xl-6 col-lg-6 col-md-6 mx-lg-auto ps-md-0" data-aos="fade-up" data-aos-duration="2000"
						data-aos-delay="100">
						<img src="{{ baseUrl }}/images/projects/spacex/glove.png" alt="ecommerce website design in dubai" width=""
							height="" loading="lazy" />
					</div>
					<div class="col-xl-6 col-lg-6 col-md-6 ps-md-0" data-aos="fade-up" data-aos-duration="2000"
						data-aos-delay="100">
						<div class="list">
							<img src="{{ baseUrl }}/images/projects/spacex/kattlebell.png" alt="web development dubai" width=""
								height="" loading="lazy" />
							<!-- <img src="{{baseUrl}}/images/projects/beyou/pack.jpg" alt="Top creative agencies in dubai" width="" height=""> -->
						</div>
					</div>
					<!-- <div class="col-xl-6 col-lg-6 col-md-6 ps-md-0" data-aos="fade-up" data-aos-duration="2000"
						data-aos-delay="100">
						<div class="list">
							<img src="{{baseUrl}}/images/projects/spacex/spacex-left.png" alt="rebranding agency dubai" width="" height="">
						</div>
					</div> -->
				</div>
			</div>
		</div>
	</div>
</section>
<section class="bg-autokoorosh typography" data-scroll-nav="5">
	<div class="container-fluid">
		<div class="row">
			<div class="col-xxl-9 col-xl-10 col-lg-11 col-md-11 col-sm-11 col-11 mx-auto">
				<div class="typography" data-aos="fade-up" data-aos-duration="2000" data-aos-delay="100">
					<img src="{{ baseUrl }}/images/projects/spacex/typography.png" alt="best design agency" width="" height=""
						loading="lazy" />
					<!-- <p data-aos="fade-up" data-aos-duration="2500" data-aos-delay="100">Through cohesive branding efforts, Pixtar helped Autokoorosh strengthen its brand presence, 
            establish credibility in the market, and attract new customers. The synergy between web development and branding ensured a holistic approach to enhancing Autokoorosh's 
            overall marketing strategy and driving business growth.</p> -->
				</div>
			</div>
		</div>
	</div>
</section>
<section class="section ui-ux" id="ui-ux" data-scroll-nav="8">
	<div class="container-fluid">
		<div class="row">
			<div class="col-xxl-9 col-xl-10 col-lg-11 col-md-11 col-sm-11 col-11 mx-auto">
				<div class="row mb-4">
					<div class="col-xxl-5 col-xl-6 col-lg-8 col-md-10 col-sm-10" data-aos="fade-up" data-aos-duration="2000"
						data-aos-delay="100">
						<div class="content">
							<h1 class="heading mb-2">UI/UX Design</h1>
							<p class="">
								The design prioritized delivering an immersive browsing
								experience, seamlessly navigating users through the gym's
								facilities,and membership options. Every element was carefully
								curated to showcase the dynamic energy and innovative approach
								of SpaceX Fitness, ensuring visitors feel motivated and
								empowered to embark on their fitness journey.
							</p>
						</div>
					</div>
				</div>
				<div class="row">
					<div class="col-lg-9 mx-lg-auto" data-aos="fade-up" data-aos-duration="2000" data-aos-delay="100">
						<!-- <video class="w-100 h-auto desktopimg" id="myVideo3" width="320" height="176" autoplay="true" muted="muted"
							loop="true" oncanplay="this.play()" onloadedmetadata="this.muted = true">
							<source src="{{baseUrl}}/images/projects/autokoorosh/autokoorosh-desktop.mp4" type="video/mp4">
							<source src="{{baseUrl}}/images/projects/autokoorosh/autokoorosh-desktop.ogg" type="video/ogg">
							Your browser does not support HTML5 video.
						</video>
						<video class="w-100 h-auto" id="myVideo3" width="320" height="176" autoplay="true" muted="muted" loop="true"
							oncanplay="this.play()" onloadedmetadata="this.muted = true">
							<source src="{{baseUrl}}/images/projects/autokoorosh/autokoorosh_laptop.mp4" type="video/mp4">
							<source src="{{baseUrl}}/images/projects/autokoorosh/autokoorosh_laptop.ogg" type="video/ogg">
							Your browser does not support HTML5 video.
						</video> -->
					</div>
				</div>
			</div>
		</div>
	</div>
</section>
<section class="technical" id="technical" data-scroll-nav="8">
	<div class="container">
		<div class="row">
			<div class="col-xxl-10 col-xl-10 col-lg-11 col-md-11 col-sm-11 col-11 mx-md-0 mx-sm-auto mx-auto">
				<div class="row mb-4">
					<div class="col-xxl-10 col-xl-12 col-lg-12 col-md-12 col-sm-12" data-aos="fade-up" data-aos-duration="2000"
						data-aos-delay="100">
						<div class="content">
							<p class="mb-md-4 -sm-3 mb-2">
								Pixtar's partnership with SpaceX Fitness has yielded a digital
								platform that seamlessly merges technology with fitness
								expertise. This case study highlights Pixtar's adeptness in
								harmonizing design, development, and functionality, delivering a
								compelling digital experience for SpaceX Fitness' audience.
							</p>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</section>
<section class="next bg-black pb-0" data-aos="fade-up" data-aos-duration="2000" data-aos-delay="100">
	<div class="container">
		<div class="row">
			<div class="col-md-12">
				<div class="next-block">
					<div class="in-line">
						<!-- {{Url}}/project-details/autokoorosh -->
						<a href="{{ Url }}/project-details/miniaar" class="text-white font-bold border-radius-25">
							<img src="{{
									baseUrl
								}}/images/projects/miniaar/branding-image-03.jpg" alt="Best Web Designers in Dubai" width="280" height="280"
								loading="lazy" />
							<h1 class="heading text-white">NEXT PROJECT</h1>
						</a>
					</div>
				</div>
			</div>
		</div>
		<div class="line"></div>
	</div>
</section>